import axios from "axios";
import { basicURL } from "../../apiManager/APIConfig";
import { store } from "../store";

const BASE = "ai/conversations";

function authHeader() {
  const token = store.getState().auth?.access_token;
  if (!token) return null;
  return token.startsWith("Bearer ") ? token : `Bearer ${token}`;
}

async function request(method, path, data) {
  const Authorization = authHeader();
  if (!Authorization) return { status: 401, message: "Please sign in again." };
  try {
    const response = await axios({
      method,
      url: `${basicURL}${path}`,
      data,
      headers: { Authorization, "Content-Type": "application/json" },
      timeout: 30000,
    });
    return response?.data;
  } catch (err) {
    if (err?.response?.data) return { status: err.response.status, ...err.response.data };
    return { status: 0, message: err?.message || "Network error." };
  }
}

export const listConversationsCall = ({ q = "", limit = 40 } = {}) =>
  request("get", `${BASE}?limit=${limit}${q ? `&q=${encodeURIComponent(q)}` : ""}`);

export const createConversationCall = ({ section_key = null, draft_state = null } = {}) =>
  request("post", BASE, { section_key, draft_state });

export const getConversationCall = (id) => request("get", `${BASE}/${encodeURIComponent(id)}`);

export const renameConversationCall = (id, title) =>
  request("patch", `${BASE}/${encodeURIComponent(id)}`, { title });

export const deleteConversationCall = (id) =>
  request("delete", `${BASE}/${encodeURIComponent(id)}`);

export const appendConversationMessagesCall = (id, messages) =>
  request("post", `${BASE}/${encodeURIComponent(id)}/messages`, { messages });

export const removeConversationMessageCall = (id, messageId) =>
  request(
    "delete",
    `${BASE}/${encodeURIComponent(id)}/messages/${encodeURIComponent(messageId)}`
  );

export const saveConversationDraftCall = (id, draft_state) =>
  request("put", `${BASE}/${encodeURIComponent(id)}/draft`, { draft_state });

export const getAssistantSourceTextCall = (sourceId) =>
  request("get", `ai/assistant-source/${encodeURIComponent(sourceId)}`);

export const updateAssistantSourceTextCall = (sourceId, { text, file_name }) =>
  request("put", `ai/assistant-source/${encodeURIComponent(sourceId)}/text`, { text, file_name });

/** AI rewrite of one document section (temporary draft text only). */
export const rewriteSectionCall = ({ text, instruction }) =>
  request("post", "ai/improve-text", { text, instruction, mode: "rewrite", context: "document" });
